import {Component, OnInit, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {AppConstants} from './shared/utils/app-constants';
import {AppConfigService} from './core/services/app-config.service';
import {AuthService} from './core/services/auth.service';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {PageDataService} from './core/services/page-data.service';
import {SidenavComponent} from './core/components/sidenav/sidenav.component';
import { CurrencyService } from './core/services/currency.service';

@Component({
  selector: '[app-root]',
  templateUrl: './app.component.html',
  styles: [`
    .sidenav-loading {
      opacity: 1;
    }
    .app-layout {
      display: flex;
      flex-direction: column;
      height: 100%;
    }
    .content-container {
      display: flex;
      flex: 1;
      overflow: hidden;
    }
    .main-content {
      flex: 1;
      overflow-x: hidden;
      overflow-y: auto;
    }
    .main-content.with-padding {
      padding: 1rem ;
    }
  `]
})
export class AppComponent implements OnInit {
  @ViewChild(SidenavComponent, {static: false}) sidenavComponent: SidenavComponent;
  sidenavLoading = true;
  isLoginPage: boolean = false;
  isDashboard: boolean = false;
  flag: boolean = false;
  count: boolean = false;
  dashboardInitialized: boolean = false;

  constructor(
    public pageDataService: PageDataService,
    public authService: AuthService,
    private translate: TranslateService,
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private currencyService: CurrencyService
  ) {
    if (AppConfigService.settings) {
      this.initLangs();
      titleService.setTitle(AppConfigService.settings.title);
    }
    
  }

  ngOnInit() {
 
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        
        this.isLoginPage = event.urlAfterRedirects.includes('/login');
        const wasDashboard = this.isDashboard;
        this.isDashboard = event.urlAfterRedirects.includes('/dashboard');

        if (this.isLoginPage) {
          this.flag = false;
          this.dashboardInitialized = false;
        } else if (!this.isDashboard) {
          this.flag = true;
        } else if (this.isDashboard) {
          if (!this.dashboardInitialized) {
            this.flag = false;
          }
          if (this.dashboardInitialized && wasDashboard !== this.isDashboard) {
            this.flag = true;
          }
        }
      }
    });
    

    if (this.authService.isLoggedIn()) {
      this.authService.updateUserInfo().subscribe();
    }

    this.activatedRoute.fragment.subscribe((fragment) => {
      if (!fragment) {
        return;
      }

      if (!this.scrollToAnchor(fragment)) {
        setTimeout(() => this.scrollToAnchor(fragment), 200);
      }
    });

    const loadRatesIfLoggedIn = () => {
      if (this.authService.isLoggedIn()) {
        this.currencyService.ensureRatesLoaded().subscribe();
      }
    };

    loadRatesIfLoggedIn();

    this.authService.userUpdated.subscribe(() => {
      loadRatesIfLoggedIn();
    });
  }

  scrollToAnchor(fragment: string): boolean {
    const element = document.querySelector('#' + fragment);
    if (element) {
      element.scrollIntoView({behavior: 'smooth', block: 'center'});
      (element as HTMLElement).focus({preventScroll: true});
      return true;
    }
    return false;
  }

  isStandardUser(): boolean {
    try {
      const isSuperAdmin = this.authService.isSuperAdmin();
      const isReadOnly = this.authService.isReadOnly();
      const isHelpDesk = this.authService.isHelpDesk();
      const isStandardUser = this.authService.isStandardUser();

      if (isSuperAdmin || isReadOnly || isHelpDesk) {
        return false;
      }

      return isStandardUser;
    } catch (error) {
      console.error('Error checking user type:', error);
      return false;
    }
  }

  initLangs() {
    if (!localStorage.getItem(AppConstants.USER_LOCALE_KEY)) {
      localStorage.setItem(AppConstants.USER_LOCALE_KEY, AppConfigService.settings.localization.supportedLanguages[0]);
    }

    const currentLang = localStorage.getItem(AppConstants.USER_LOCALE_KEY);
    this.translate.addLangs(AppConfigService.settings.localization.supportedLanguages);
    this.translate.setDefaultLang(currentLang);
    this.translate.use(currentLang);

    // Optimize language preference switching performance via background pre-fetching (cache warming)
    const supported = AppConfigService.settings.localization.supportedLanguages || [];
    supported.forEach((lang: string) => {
      if (lang !== currentLang) {
        this.translate.getTranslation(lang).subscribe({
          error: (err) => console.warn(`Translation pre-fetch failed for language ${lang}:`, err)
        });
      }
    });
  }

  onRouteActivate(component: any) {
    const currentUrl = this.router.url;
    const isDashboardRoute = currentUrl.includes('/dashboard');
    
    if (isDashboardRoute && !this.dashboardInitialized) {
      setTimeout(() => {
        if (this.sidenavComponent) {
          this.sidenavComponent.updateSidenav();
          this.sidenavComponent.updateHeight();
        }
        this.flag = true;
        this.dashboardInitialized = true;
      }, 0);
    }
  }
}